import { Link } from "react-router-dom";
import { Facebook, Instagram, Phone, MapPin, MessageCircle, Mail, Lock } from "lucide-react";

const Footer = () => {
  return (
    <footer className="vd-footer mt-20" data-testid="site-footer">
      <div className="vd-container py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        {/* Contact column — matches IMG_9612 mockup format */}
        <div>
          <h3 style={{ fontSize: 20, marginBottom: 16 }}>Contact</h3>
          <ul className="space-y-4 text-[15px]">
            <li className="flex items-start gap-3">
              <span className="inline-flex items-center justify-center rounded-full mt-0.5" style={{ width: 34, height: 34, background: "rgba(230,0,0,0.08)" }}>
                <Phone size={18} color="var(--primary-red)" />
              </span>
              <div className="flex flex-col" data-testid="footer-call-us">
                <a href="tel:07979210250" className="font-semibold">07979 210250</a>
                <a href="tel:07498408406" className="font-semibold" data-testid="footer-call-us-2">07498 408406</a>
              </div>
            </li>
            <li className="flex items-center gap-3">
              <span className="inline-flex items-center justify-center rounded-full" style={{ width: 34, height: 34, background: "rgba(230,0,0,0.08)" }}>
                <MapPin size={18} color="var(--primary-red)" />
              </span>
              <span data-testid="footer-location">Middlesbrough, UK <span className="vd-muted">|</span> Open 24/7</span>
            </li>
            <li className="flex items-center gap-3">
              <span className="inline-flex items-center justify-center rounded-full" style={{ width: 34, height: 34, background: "rgba(230,0,0,0.08)" }}>
                <MessageCircle size={18} color="var(--primary-red)" />
              </span>
              <a href="https://wa.me/447979210250" target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp">WhatsApp: +44 7979 210250</a>
            </li>
            <li className="flex items-center gap-3">
              <span className="inline-flex items-center justify-center rounded-full" style={{ width: 34, height: 34, background: "rgba(230,0,0,0.08)" }}>
                <Mail size={18} color="var(--primary-red)" />
              </span>
              <a href="mailto:info@valuedriveauto.co.uk" className="break-all" data-testid="footer-email">info@valuedriveauto.co.uk</a>
            </li>
          </ul>
        </div>

        <div>
          <h3 style={{ fontSize: 20, marginBottom: 16 }}>Quick Links</h3>
          <ul className="space-y-2 text-[15px]">
            <li><Link to="/tyres" data-testid="footer-link-tyres">Shop Auto Parts</Link></li>
            <li><Link to="/tyres" data-testid="footer-link-services">Tyres &amp; Batteries</Link></li>
            <li><Link to="/recovery" data-testid="footer-link-recovery">Request Recovery</Link></li>
            <li><Link to="/mobile-fitting" data-testid="footer-link-mobile-fitting">Mobile Fitting</Link></li>
            <li><Link to="/order/track" data-testid="footer-link-track">Track Order</Link></li>
          </ul>
        </div>

        <div>
          <h3 style={{ fontSize: 20, marginBottom: 16 }}>Customer Care</h3>
          <ul className="space-y-2 text-[15px]">
            <li><Link to="/faq">FAQs</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/returns">Returns Policy</Link></li>
            <li><Link to="/privacy">Privacy Policy</Link></li>
          </ul>
        </div>

        <div>
          <h3 style={{ fontSize: 20, marginBottom: 16 }}>Follow Us</h3>
          <div className="flex items-center gap-3">
            <a
              href="#"
              aria-label="Facebook"
              data-testid="social-facebook"
              className="inline-flex items-center justify-center rounded-md transition-transform hover:scale-110"
              style={{ width: 40, height: 40, background: "#1877F2", color: "#FFFFFF" }}
            ><Facebook size={20} fill="#FFFFFF" /></a>
            <a
              href="#"
              aria-label="Instagram"
              data-testid="social-instagram"
              className="inline-flex items-center justify-center rounded-md transition-transform hover:scale-110"
              style={{ width: 40, height: 40, background: "linear-gradient(45deg,#F58529,#DD2A7B,#8134AF,#515BD4)", color: "#FFFFFF" }}
            ><Instagram size={20} color="#FFFFFF" /></a>
          </div>
          <p className="vd-muted mt-5 text-sm">24/7 emergency callouts across Middlesbrough &amp; Teesside.</p>
        </div>
      </div>

      <div className="border-t" style={{ borderColor: "var(--border-color)" }}>
        <div className="vd-container py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="vd-muted text-sm">© {new Date().getFullYear()} ValueDrive Auto Solutions. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <Link to="/admin/login" className="vd-muted text-sm inline-flex items-center gap-1.5 hover:text-[var(--primary-red)] transition-colors" data-testid="footer-owner-login"><Lock size={12} /> Owner login</Link>
            <p className="vd-muted text-sm">Driven by Quality. · Powered by Trust.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
